<template>
  <form @submit.prevent="submit">
    <input
      v-model="email"
      class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      placeholder="email"
    >

    <input
      v-model="password"
      class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      type="password"
      placeholder="mot de passe"
    >

    <div class="flex justify-center">
      <button
        type="submit"
        class="block bg-indigo-500 hover:bg-indigo-500px-4 py-2 rounded text-white shadow"
      >
        Connexion
      </button>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      password: null
    }
  },

  methods: {
    async submit() {
      const params = {
        admin: {
          email: this.email,
          password: this.password
        }
      }

      try {
        const { data } = await this.$axios.post('/admins/login', params)

        this.$store.commit('auth/SET_TOKEN', data.jwt)

        this.email = null
        this.password = null

        this.$router.push('/home')
      } catch (err) {
        alert('Une erreur c\'est produite')
      }
    }
  }
}
</script>
